export class Fecha {
  dia:string='';
  mes:string='';
  anio:string='';
  hora:string='';
  minuto:string='';
  segundo:string='';
}
